import { Segmented, SegmentedOption } from '@pointfive/ui';
import { SettingRow } from './kit';

/** A setting picked from two or three options, as a segmented control.
 *
 *  The design's segmented selector is the app's primary selection signal — the rail-dark active state described in
 *  `design-reference/CLAUDE.md` — so a settings choice uses it rather than inventing a second way to say "this one".
 *  The literals below are the reference's own.
 */
export function ChoiceRow({
  label,
  hint,
  value,
  options,
  onPick,
  disabled = false,
}: {
  label: string;
  hint?: string;
  value: string;
  options: readonly (readonly [string, string])[];
  onPick: (value: string) => void;
  disabled?: boolean;
}) {
  return (
    <SettingRow label={label} hint={hint}>
      <Segmented>
        {options.map(([id, text]) => {
          const on = id === value;
          return (
            <SegmentedOption
              key={id}
              bg={on ? 'var(--rail)' : 'transparent'}
              fg={on ? 'var(--rail-ink)' : 'var(--muted)'}
              fw={on ? '600' : '500'}
              title={`${label}: ${text}`}
              aria-label={`${label}: ${text}`}
              aria-pressed={on}
              // A disabled pick is a no-op rather than a removed control: hiding the other options while a save is
              // in flight makes the row jump.
              onClick={() => {
                if (!disabled && !on) onPick(id);
              }}
            >
              {text}
            </SegmentedOption>
          );
        })}
      </Segmented>
    </SettingRow>
  );
}
